export enum MessageType {
    Error,
    Success,
    Notification,
    Warning,
}

export enum IconsByType {
    Alert = 'alert',
    Success = 'check',
    Notification = 'info',
}

export enum IconColor {
    Warning = '#E4A13C',
    Success = '#49AE72',
    Error = '#E45275',
    Notification = '#5C9DCC',
    Default = '#5C9DCC',
}

export enum SnackBarHorizontalPosition {
    Right = 'right',
    Left = 'left',
}

export enum SnackBarVerticalPosition {
    Top = 'top',
    Bottom = 'bottom',
}

export enum SnackBarClass {
    Config = 'snackbar-config',
    Error = 'msg-error',
    Success = 'msg-success',
    Warning = 'msg-warning',
    Default = 'msg-default',
}
